import React, { useEffect, useRef } from 'react';
import { Row, Col } from "antd";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Img1 from '../assets/box1/box1.png';
import Ban from '../assets/feature.png';

gsap.registerPlugin(ScrollTrigger);

function Feature() {
  const sectionRef = useRef(null);
  const featureImgRef = useRef(null);
  const stepsRef = useRef([]);

  const steps = [
    {
      id: "01",
      title: "First Of All Have To Add Your Shirt Design",
      desc: "Lorem Ipsum Det, Cowec Tetur Duis Nec Fringi Det, Consec T Eturlagix Adipisicing Eliet,",
      active: false,
    },
    {
      id: "02",
      title: "Pixel Perfect And Accurate Great Printing",
      desc: "Lorem Ipsum Det, Cowec Tetur Duis Nec Fringi Det, Consec T Eturlagix Adipisicing Eliet,",
      active: true,
    },
    {
      id: "03",
      title: "Low Cost & Digital Printing Agency & Enjoy It",
      desc: "Lorem Ipsum Det, Cowec Tetur Duis Nec Fringi Det, Consec T Eturlagix Adipisicing Eliet,",
      active: false,
    },
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate title
      gsap.from(".feature-text h4", {
        y: 40,
        opacity: 0,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".feature-text",
          start: "top 80%",
        },
      });

      gsap.from(".feature-text h2", {
        y: 60,
        opacity: 0,
        duration: 1.4,
        ease: "power4.out",
        scrollTrigger: {
          trigger: ".feature-text h2",
          start: "top 85%",
        },
      });

      // Feature Icons animation
      gsap.from(".feature-img li", {
        y: 80,
        opacity: 0,
        stagger: 0.2,
        duration: 1.2,
        ease: "back.out(1.7)",
        scrollTrigger: {
          trigger: ".feature-img",
          start: "top 80%",
        },
      });

      // Left image slide in
      gsap.from(featureImgRef.current, {
        x: -100,
        opacity: 0,
        duration: 1.3,
        ease: "power3.out",
        scrollTrigger: {
          trigger: featureImgRef.current,
          start: "top 85%",
        },
      });

      // Timeline steps animation
      stepsRef.current.forEach((el, i) => {
        gsap.from(el, {
          x: 100,
          opacity: 0,
          duration: 1.2,
          delay: i * 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
          },
        });
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="featuretask bg-[#FCF5FC] pt-[80px] pb-[80px]">
      <div className="container pt-[80px] pb-[80px]">
        {/* Top Features Section */}
        <Row>
          <Col span={24}>
            <div className="feature-text">
              <h4 className='text-center font-custom text-[35px]'>
                <span className='text-[#6cc5bf] text-4xl'>_ </span>
                Available Features
              </h4>

              <h2 className='text-center font-bold text-[50px] m-auto w-[80%] font-custom'>
                Initial Global Trade: Here for Printing business since 1995.
              </h2>
            </div>
          </Col>

          <Col span={24}>
            <div className="feature-img pt-10">
              <ul className='flex flex-wrap justify-center gap-[40px] m-auto text-center'>
                {[
                  "STARTING FROM 100 BOXES",
                  "Eco-friendly Local Products",
                  "500,00+ Customisable Products",
                  "Custom Brand Tools for Print",
                  "Exclusive Team Members"
                ].map((text, i) => (
                  <li key={i} className='flex flex-col items-center pt-5'>
                    <img src={Img1} alt="" />
                    <span className='pt-3 text-[18px] font-outfit'>{text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>

        {/* Timeline Section */}
        <Row className="pt-[80px]" gutter={[25, 25]} align="middle">
          <Col xs={24} md={12}>
            <img ref={featureImgRef} src={Ban} alt="Feature" className="w-full" />
          </Col>

          <Col xs={24} md={12}>
            <div className="relative border-l-2 border-gray-200 ml-10">
              {steps.map((step, index) => (
                <div
                  key={index}
                  ref={(el) => (stepsRef.current[index] = el)}
                  className="relative mb-10 pl-10"
                >
                  {/* Circle Number */}
                  <div
                    className={`absolute -left-6 top-0 w-12 h-12 flex items-center justify-center rounded-full text-lg font-semibold font-custom ${step.active
                      ? "bg-[#6cc5bf] text-white shadow-md"
                      : "bg-white border border-gray-200 text-black"
                      }`}
                  >
                    {step.id}
                  </div>

                  {/* Text */}
                  <div className='text-tempo p-50'>
                    <h4 className="font-semibold text-[25px] font-custom mb-1">
                      {step.title}
                    </h4>
                    <p
                      style={{ lineHeight: '30px' }}
                      className="w-[500px] mt-1 text-gray-500 text-[16px] font-custom leading-snug"
                    >
                      {step.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default Feature;
